import { createFileRoute } from '@tanstack/react-router';
import { cacheHeadersFor, experimentalRoutes } from '@/analytics';
import { MARKETING_CACHE_CONTROL } from '@/analytics/cache-headers';
import { AudioPage } from '@/components/astro/pages/audio';
import { seo } from '@/seo/seo';

const ANALYTICS = experimentalRoutes['/_marketing/_seo/_legacy/audio'];

/**
 * `/audio` — the only SEO route registered for `pricing-test-v1`, because it is
 * the only one of the six `FeaturesCardSection` pages with the traffic to keep
 * six cache entries fed (1,612 pageviews in the 90 days to 2026-08-25, against
 * 15–50 for the other five). `experimental-routes.ts` carries the full
 * comparison.
 *
 * Not country-keyed: the features card quotes a price but renders no free-plan
 * copy, so this path costs 6 entries where `/pricing` costs 12.
 *
 * `MARKETING_CACHE_CONTROL` is what the `_marketing` layout was already giving
 * this path; stated here so registering the experiment does not silently
 * shorten its TTL to `cacheHeadersFor`'s default — six entries need the longer
 * window more than one did, not less.
 */
export const Route = createFileRoute('/_marketing/_seo/_legacy/audio')({
  staticData: { analytics: ANALYTICS },
  headers: cacheHeadersFor(ANALYTICS, MARKETING_CACHE_CONTROL),
  head: () => ({
    meta: [
      ...seo({
        title: 'Audio | Convert Academic Research to Audio with Listening',
        description:
          'Stream academic papers, books, and PDFs anytime, anywhere. Dive into a world of audio learning and get started today! | Audio',
      }),
    ],
  }),
  component: () => <AudioPage />,
});
